export default __webpack_public_path__ + "static/media/img_bg.61a15288.png";